// src/components/Common/WebSocketProvider.tsx
import React, { useEffect } from 'react';
import { useWebSocket } from '../../hooks/useWebSocket';

interface WebSocketProviderProps {
  children: React.ReactNode;
}

const WebSocketProvider: React.FC<WebSocketProviderProps> = ({ children }) => {
  const { isConnected, socket, reconnect } = useWebSocket();

  useEffect(() => {
    console.log('🌐 WebSocket Provider initialized, connection status:', isConnected);
  }, [isConnected]);

  // Optionally show connection status in development
  const showDebugInfo = process.env.NODE_ENV === 'development';

  return (
    <>
      {children}
      {showDebugInfo && (
        <div
          style={{
            position: 'fixed',
            bottom: '1rem',
            left: '1rem',
            padding: '0.5rem 1rem',
            backgroundColor: isConnected ? 'var(--color-success)' : 'var(--color-error)',
            color: 'var(--color-text-inverse)',
            borderRadius: '20px',
            fontSize: '0.75rem',
            zIndex: 9999,
            cursor: isConnected ? 'default' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem'
          }}
          onClick={!isConnected ? reconnect : undefined}
          title={!isConnected ? 'Click to reconnect' : 'WebSocket connected'}
        >
          <div
            style={{
              width: '8px',
              height: '8px',
              borderRadius: '50%',
              backgroundColor: 'var(--color-text-inverse)',
              animation: isConnected ? 'none' : 'pulse 1s infinite'
            }}
          />
          WebSocket {isConnected ? 'Connected' : 'Disconnected'}
        </div>
      )}
    </>
  );
};

export default WebSocketProvider;